module.exports = __webpack_public_path__ + "img/logo.49571110.png";